export const OCCUPATIONS_EXPLORE_PATHNAME = 'occupations?activeTab=1';
export const LEARNING_PATHS_PATHNAME = 'learning-paths';
